export default {
  INVALID_GEOMETRY: 'Invalid geometry',
  INVALID_FIELD: 'Invalid field',
  UNKNOWN: 'Unknown error',
};
